import { type Verdict } from '@exam-center/graphql';
import { Box, EventAvailableOutlinedIcon, Flex, Text } from '@shared/components';

import { VerdictResultLabel } from '../verdict-result-label';
interface ExamCenterProctorRequestVerdictResultCardProps {
  fullName: string;
  comment: string;
  submittedAt: string;
  approverNumber: number;
  verdict: Verdict;
}

export default function ExamCenterProctorRequestVerdictResultCard(
  props: Readonly<ExamCenterProctorRequestVerdictResultCardProps>,
) {
  const { fullName, comment, submittedAt, approverNumber, verdict } = props;

  return (
    <Box
      sx={(theme) => ({
        p: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: theme.shape.rounded(2),
      })}
    >
      <Flex
        sx={(theme) => ({
          borderLeft: '4px solid',
          pl: theme.spacing(4),
          borderColor:
            verdict === 'APPROVED' ? theme.palette.success.main : theme.palette.error.main,
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        })}
      >
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(2) }}>
          <Text>
            ผู้อนุมัติลำดับที่ {approverNumber}: <Text variant='body1Semibold'>{fullName}</Text>
          </Text>
          <Text variant='body2' color='text.secondary'>
            ความคิดเห็นเพิ่มเติม: {comment}
          </Text>
          <Flex sx={{ gap: (theme) => theme.spacing(1), alignItems: 'center' }}>
            <EventAvailableOutlinedIcon
              sx={{ color: (theme) => theme.palette.text.secondary, fontSize: 16 }}
            />
            <Text variant='body2' color='text.secondary'>
              วันที่อนุมัติ: {submittedAt}
            </Text>
          </Flex>
        </Flex>
        <VerdictResultLabel variant={verdict} />
      </Flex>
    </Box>
  );
}
